import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var bnr1 = require('./../../images/background/bg-6.png');

class SimilarProjects extends React.Component {
    state = {
        projects: [],
        loading: true
    };

    componentDidMount() {
        this.fetchProjects();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentProjectSlug !== this.props.currentProjectSlug) {
            this.fetchProjects();
        }
    }

    fetchProjects() {
        axiosClient.get(apiConfig.PROJECTS.GET_ALL)
            .then(res => {
                const all = res.data.data || [];
                const currentSlug = this.props.currentProjectSlug;
                const serviceSlug = this.props.serviceSlug;

                // Exclude current project
                let filtered = all.filter(p => p.slug !== currentSlug);

                // If serviceSlug provided, prioritize projects in same service
                if (serviceSlug) {
                    const sameService = filtered.filter(p => p.service?.slug === serviceSlug);
                    const otherService = filtered.filter(p => p.service?.slug !== serviceSlug);
                    filtered = [...sameService, ...otherService];
                }

                this.setState({
                    projects: filtered,
                    loading: false
                });
            })
            .catch(err => {
                console.error("Error fetching similar projects", err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { projects, loading } = this.state;

        if (loading || projects.length === 0) {
            return null;
        }

        const options = {
            loop: projects.length > 3,
            autoplay: true,
            center: false,
            items: 3,
            margin: 40,
            nav: true,
            dots: false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: { items: 1 },
                768: { items: 2 },
                991: { items: 3 },
                1200: { items: 4 }
            }
        };

        return (
            <div className="section-full p-t80 p-b30 bg-dark bg-repeat square_shape2 bg-moving" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                <div className="container">
                    <div className="section-head">
                        <div className="mt-separator-outer separator-center">
                            <div className="mt-separator">
                                <h2 className="text-white text-uppercase sep-line-one ">
                                    <span className="font-weight-300 text-primary">Similar</span> projects
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-content container-fluid">
                    <div className="similar-carousel-outer">
                        <OwlCarousel
                            key={projects.length}
                            className="owl-carousel similar-projects owl-btn-vertical-center"
                            {...options}
                        >
                            {projects.map((item, index) => {
                                const desc = (item.short_description || item.description || '').substring(0, 95);
                                return (
                                    <div key={item.id || index} className="item mt-box">
                                        <div className="mt-img-effect mt-img-overlay7">
                                            <img
                                                style={{
                                                    width: "100%",
                                                    height: "380px",
                                                    objectFit: "cover"
                                                }}
                                                src={item.featured_image}
                                                alt={item.title}
                                            />
                                        </div>
                                        <div className="mt-info p-a30">
                                            {item.service && (
                                                <span className="text-primary font-weight-600 font-12 text-uppercase m-b10 block">
                                                    {item.service.name}
                                                </span>
                                            )}
                                            <h4 className="m-b15 m-t0">
                                                <NavLink
                                                    to="/project-detail"
                                                    state={{ projectSlug: item.slug }}
                                                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                >
                                                    {item.title}
                                                </NavLink>
                                            </h4>
                                            {desc && <p>{desc}...</p>}
                                            <NavLink
                                                to="/project-detail"
                                                state={{ projectSlug: item.slug }}
                                                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                                                className="site-button btn-effect"
                                            >
                                                View Project
                                            </NavLink>
                                        </div>
                                    </div>
                                );
                            })}
                        </OwlCarousel>
                    </div>
                </div>
                <div className="hilite-title text-left p-l50 text-uppercase hilite-dark">
                    <strong>projects</strong>
                </div>
            </div>
        );
    }
}

export default SimilarProjects;
